import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { PaymentMethodsResponse } from '../../responses/platform/payment-methods.response';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getAuthorPaymentMethods(): Observable<PaymentMethodsResponse> {
    return this.http
      .get<PaymentMethodsResponse>(
        environment.urlApiPlatform + 'PaymentMethods/AuthorPaymentMethods',
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public getCreditsPaymentMethods(): Observable<PaymentMethodsResponse> {
    return this.http
      .get<PaymentMethodsResponse>(
        environment.urlApiPlatform + 'PaymentMethods/CreditsPaymentMethods',
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
